import { useCallback, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { exportDashboardWorkbook } from './excelWorkbook';

export default function useDashboardExcelExport({
    fileName,
    sections,
    metadata,
    disabled,
    disabledMessage,
    beforeExportMessage,
    successMessage,
    onBeforeExport
}) {
    const [isExporting, setIsExporting] = useState(false);

    const canExport = useMemo(() => !disabled && !isExporting, [disabled, isExporting]);

    const onExport = useCallback(async () => {
        if (disabled) {
            if (disabledMessage) {
                toast.info(disabledMessage);
            }
            return;
        }

        setIsExporting(true);
        const toastId = toast.loading(beforeExportMessage || 'Preparing Excel export...');
        try {
            onBeforeExport?.({ sections, metadata });
            await exportDashboardWorkbook({
                fileName,
                sections,
                metadata
            });
            toast.update(toastId, {
                render: successMessage || 'Excel export is ready.',
                type: 'success',
                isLoading: false,
                autoClose: 4000
            });
        } catch (error) {
            console.error(error);
            toast.update(toastId, {
                render: 'Unable to generate Excel export. Please try again.',
                type: 'error',
                isLoading: false,
                autoClose: 5000
            });
        } finally {
            setIsExporting(false);
        }
    }, [
        beforeExportMessage,
        disabled,
        disabledMessage,
        fileName,
        metadata,
        onBeforeExport,
        sections,
        successMessage
    ]);

    return {
        onExport,
        canExport,
        isExporting
    };
}

